import axiosService from './axiosService';
import authService from './authService';

const formatData = (code) => ({
  code,
  token: authService.getAccessToken()
});

class AccountService {
  login = (username, password) => axiosService.post('/api/login', { username, password });

  loginWithToken = (token) => axiosService.get(`/api/login/${token}`);

  authenticate = (code) => axiosService.post('/api/login/authenticate', formatData(code));

  loginWithSsoToken = (ssotokenrequest) => axiosService.post('/api/login/sso/token', { ssotokenrequest });

  logout = () => axiosService.post('/api/tokens/revoke', authService.getTokenObj());

  loadUser = () => axiosService.get(`/api/users/${authService.getUserId()}`);
}

const accountService = new AccountService();
export default accountService;
